require('./accountBringBankAccount.scss');

// @ vendor
const React = require('react');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ constants
const { ACCOUNT_BRING_BANK_ACCOUNT_PRODUCT_ALIAS, ACCOUNT_BRING_BANK_ACCOUNT_UI_COMPONENT_ID } = require('constants/accounts');

class AccountBringBankAccount extends React.Component {
    buildSteps() {
        const steps = [
            {
                icon: '',
                title: 'accountBringBankAccount-accountBringBankAccount_title01',
                description: 'accountBringBankAccount-accountBringBankAccount_description01'
            },
            {
                icon: 'account-bring-bank-account__steps-icon--2',
                title: 'accountBringBankAccount-accountBringBankAccount_title02',
                description: 'accountBringBankAccount-accountBringBankAccount_description02'
            },
            {
                icon: 'account-bring-bank-account__steps-icon--3',
                title: 'accountBringBankAccount-accountBringBankAccount_title03',
                description: 'accountBringBankAccount-accountBringBankAccount_description03'
            }
        ];

        const addressText = [
            'accountBringBankAccount-accountBringBankAccount_address01',
            'accountBringBankAccount-accountBringBankAccount_address02',
            'accountBringBankAccount-accountBringBankAccount_address03'
        ]

        const items = steps.map((step, index) => (
            <div key={`step-${index}`} className="account-bring-bank-account__steps-description">
                <div className="account-bring-bank-account__steps-number">
                    <i className={`account-bring-bank-account__steps-icon ${step.icon}`} />
                    <div className="account-bring-bank-account__steps-title">
                        <FormattedText value={step.title} />
                    </div>
                </div>
                <FormattedText value={step.description} />
            </div>
        ));

        const address = addressText.map((item, index) => (
            <div key={`address-${index}`} className="account-bring-bank-account__steps-address">
                <FormattedText value={item} />
            </div>
        ));

        return (
            <ContentBox
                customClassName="account-bring-bank-account__steps"
                title={formatText('accountBringBankAccount-accountBringBankAccount_boxTitle')}
            >
                {items}
                {address}
            </ContentBox>
        );
    }

    buildCallMeBack() {
        return (
            <div className="account-bring-bank-account__callmeback">
                <CallMeBack pageTitle={formatText('breadcrumb-accounts')} hasEntrance={false} />
            </div>
        )
    }

    render() {
        const callMeBack = this.buildCallMeBack();
        const steps = this.buildSteps();

        return (
            <div className="row">
                <div className="col-xs-8 ok-section-box">
                    <HiringProductInformation
                        productAlias={ACCOUNT_BRING_BANK_ACCOUNT_PRODUCT_ALIAS}
                        productComponentId={ACCOUNT_BRING_BANK_ACCOUNT_UI_COMPONENT_ID}
                        precontractualLinkTarget="_blank"
                    />
                </div>
                <div className="col-xs-4">
                    {steps}
                    {callMeBack}
                </div>
            </div>
        )
    }
}

module.exports = AccountBringBankAccount;
